<dl class="row">
  <dt [ngClass]="titleClass">
    {{ title }}
    <br>
    <ng-content></ng-content>
  </dt>
</dl>
